import produce from "immer"
import toast, { Toaster } from 'react-hot-toast';


import {
    DISPATCH_EVENT3,
    CHANGE_STATUS3,
    DISPATCH_EVENT3_SUCCESS,
    CHANGE_STATUS3_SUCCESS,
    SET_VALIDATION_MESSAGE3,
    FORM_CLOSE3,
    LOAD_FORM3_SUCCESS
} from "../constants";

const initialState = {
    disableInput: false,
    errors : null,
    warnings:null,
    success: null,
};

const ui3Reducer = produce((draft, action) => {

    switch (action.type) {
        case CHANGE_STATUS3:
        case DISPATCH_EVENT3:
            // We disabled inputs, but that caused UI-issues when setting onChange for input. 
            // So if we need to disableInput for events ensure it will work with onChange for input
            //draft.disableInput = true;
            break;
        // Added 2021-05: If we submitted two forms, second one was always disabled.
        case LOAD_FORM3_SUCCESS: {
            draft.disableInput = false;
            break;
        }
        case SET_VALIDATION_MESSAGE3:
        case DISPATCH_EVENT3_SUCCESS:
        case CHANGE_STATUS3_SUCCESS:
            draft.disableInput = false;
            draft.errors = action.errors;
            draft.warnings =  action.warnings;
            draft.success = action.success;
            break;
        case FORM_CLOSE3: {
            draft.disableInput = false;
            break;
        }
        default:
            break;
    }
},initialState);

export default ui3Reducer;

export const getIsInputDisabled = state => {
    return state.disableInput;
};

export const getErrors = state => {
    return state.errors;
};

export const getWarnings = state => {
    return state.warnings;
};

export const getSuccess = state => {
    return state.success;
};
  
